"use client";
import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import Skeleton from "../../feedback/Skeleton/Skeleton.js";
import Paragraph from "../../typography/Paragraph/Paragraph.js";
import { useState, useEffect } from "react";
import { resolveLocalAsset } from "./Image.helpers.js";
import '../../../assets/PlaceholderImage.css';const root = "_root_1uibs_2";
const figure = "_figure_1uibs_20";
const imageWrapper = "_imageWrapper_1uibs_35";
const image = "_image_1uibs_35";
const placeholder = "_placeholder_1uibs_75";
const heightPlaceholder = "_heightPlaceholder_1uibs_86";
const backgroundImage = "_backgroundImage_1uibs_93";
const backgroundImageInner = "_backgroundImageInner_1uibs_97";
const fill = "_fill_1uibs_106";
const overlay = "_overlay_1uibs_110";
const ImageStyles = {
  root,
  figure,
  imageWrapper,
  image,
  placeholder,
  heightPlaceholder,
  backgroundImage,
  backgroundImageInner,
  fill,
  overlay
};
let fallbackIndex = 0;
const PlaceholderImage = (props) => {
  const { width, height, tracker, title, placeholder: placeholder2 } = props;
  const IMAGES_COUNT = 8;
  const [fallbackImage, setFallbackImage] = useState("");
  useEffect(() => {
    switch (fallbackIndex) {
      case 0:
        import("../../../beige-DWZoYceX.js").then((img) => {
          setFallbackImage(resolveLocalAsset(img.default, tracker));
        });
        break;
      case 1:
        import("../../../blue-C4j9fUVq.js").then((img) => {
          setFallbackImage(resolveLocalAsset(img.default, tracker));
        });
        break;
      case 2:
        import("../../../brown-DHU8alpb.js").then((img) => {
          setFallbackImage(resolveLocalAsset(img.default, tracker));
        });
        break;
      case 3:
        import("../../../green-EuBsIQlj.js").then((img) => {
          setFallbackImage(resolveLocalAsset(img.default, tracker));
        });
        break;
      case 4:
        import("../../../grey-D1u3lOEK.js").then((img) => {
          setFallbackImage(resolveLocalAsset(img.default, tracker));
        });
        break;
      case 5:
        import("../../../magenta-VvPLyj7w.js").then((img) => {
          setFallbackImage(resolveLocalAsset(img.default, tracker));
        });
        break;
      case 6:
        import("../../../purple-DLQtE0Uy.js").then((img) => {
          setFallbackImage(resolveLocalAsset(img.default, tracker));
        });
        break;
      case 7:
        import("../../../turkise-CId3qfMT.js").then((img) => {
          setFallbackImage(resolveLocalAsset(img.default, tracker));
        });
        break;
      default:
        import("../../../brown-DHU8alpb.js").then((img) => {
          setFallbackImage(resolveLocalAsset(img.default, tracker));
        });
    }
    if (fallbackIndex >= IMAGES_COUNT - 1) {
      fallbackIndex = 0;
    } else {
      fallbackIndex += 1;
    }
  }, []);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    placeholder2 && /* @__PURE__ */ jsx("div", { className: ImageStyles.placeholder, title, children: /* @__PURE__ */ jsx(Paragraph, { text: placeholder2, align: "center", size: "caption" }) }),
    !placeholder2 && !fallbackImage && /* @__PURE__ */ jsx(Skeleton, { width, height }),
    !placeholder2 && fallbackImage && /* @__PURE__ */ jsx(
      "img",
      {
        width,
        height,
        src: fallbackImage,
        alt: "Stedfortrædende billede",
        "data-width-type": width,
        "data-height-type": height,
        className: ImageStyles.image
      }
    )
  ] });
};
export {
  ImageStyles as I,
  PlaceholderImage as default
};
